import { Controller } from "@hotwired/stimulus"

// Connect with: data-controller="depay-widget"
export default class extends Controller {
  // Trigger with: click->depay-widget#buy
  buy(event) {
    event.preventDefault()

    const w = window
    if (!w.DePayWidgets || !w.DePayWidgets.Sale) {
      console.warn("DePayWidgets not available on window.")
      return
    }

    w.DePayWidgets.Sale({
      tokenImage: "https://depay.com/favicon.png",
      sell: {
        ethereum: "0xa0bEd124a09ac2Bd941b10349d8d224fe3c955eb",
        bsc:      "0xa0bEd124a09ac2Bd941b10349d8d224fe3c955eb",
        solana:   "DePay1miDBPWXs6PVQrdC5Vch2jemgEPaiyXLNLLa2NF"
      }
    })
  }
}
